module.exports = __webpack_public_path__ + "img/tigong2.1b9ff612.png";